module.exports = __webpack_public_path__ + "img/quienes.ae9b48be.png";